/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleType
 */
export interface VehicleType {
    /**
     * 
     * @type {string}
     * @memberof VehicleType
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleType
     */
    label: string;
}

/**
 * Check if a given object implements the VehicleType interface.
 */
export function instanceOfVehicleType(value: object): value is VehicleType {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function VehicleTypeFromJSON(json: any): VehicleType {
    return VehicleTypeFromJSONTyped(json, false);
}

export function VehicleTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleType {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
    };
}

export function VehicleTypeToJSON(json: any): VehicleType {
    return VehicleTypeToJSONTyped(json, false);
}

export function VehicleTypeToJSONTyped(value?: VehicleType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
    };
}

